export class JiraProjectCredential {
    projectName: string;
    jiraKey: string;
    projectId?: string;

    constructor(projectName: string, jiraKey: string, projectId?: string) {
        this.projectName = projectName;
        this.jiraKey = jiraKey;
        this.projectId = projectId;
    }
}
